import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "StepNavbar",
  props: {
    pages: {
      type: Array,
      required: true
    },
    current: {
      type: String,
      default: null
    },
    showControls: {
      type: Boolean,
      default: true
    },
    showLogo: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    currentStepIndex() {
      var _context;
      return _findIndexInstanceProperty(_context = this.pages).call(_context, ({
        key
      }) => key === this.current);
    },
    percent() {
      return 100 / this.pages.length;
    },
    currentPercent() {
      return 100 - (this.currentStepIndex + 1) * this.percent;
    },
    isPreviousItemCompleted() {
      return this.currentStepIndex > 0;
    },
    isNextItemCompleted() {
      return this.currentStepIndex < this.pages.length && this.isCompleted(this.current);
    }
  },
  methods: {
    allPreviousCompleted(page, index) {
      var _context2;
      const previous = _sliceInstanceProperty(_context2 = this.pages).call(_context2, 0, index);
      return previous.every(p => this.isCompleted(p));
    },
    isCompleted(page) {
      return page.completed;
    },
    handleClick(key, index) {
      if (!this.allPreviousCompleted(key, index) && !this.isCompleted(key)) return;
      this.$emit("navigate", index);
    },
    handlePreviousStepClick() {
      if (!this.isPreviousItemCompleted) return;
      const prevStepIndex = this.currentStepIndex - 1;
      this.handleClick(this.pages[prevStepIndex], prevStepIndex);
    },
    handleNextStepClick() {
      if (!this.isNextItemCompleted) return;
      const nextStepIndex = this.currentStepIndex + 1;
      this.handleClick(this.pages[nextStepIndex], nextStepIndex);
    }
  }
});